import { useSchoolYear, getSchoolYearLabel } from "../../context/SchoolYearContext";

function statusLabel(status) {
  switch (status) {
    case "active":
      return "aktywny";
    case "draft":
      return "wersja robocza";
    case "archived":
      return "archiwum";
    default:
      return status ?? "brak statusu";
  }
}

export default function SchoolYearSwitcher() {
  const {
    schoolYears,
    selectedSchoolYearId,
    selectedSchoolYear,
    setSelectedSchoolYearId,
    isSelectedYearDraft,
    isSelectedYearArchived,
    loading,
    error,
  } = useSchoolYear();

  if (loading) {
    return (
      <div className="rounded-[24px] border border-white/70 bg-white/78 px-5 py-4 text-sm text-slate-500 shadow-[0_12px_28px_rgba(15,23,42,0.05)]">
        Ładowanie lat szkolnych...
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-[24px] border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-700 shadow-[0_12px_28px_rgba(15,23,42,0.05)]">
        Nie udało się pobrać lat szkolnych.
      </div>
    );
  }

  if (schoolYears.length === 0) {
    return (
      <div className="rounded-[24px] border border-amber-200 bg-amber-50 px-5 py-4 text-sm text-amber-800 shadow-[0_12px_28px_rgba(15,23,42,0.05)]">
        Brak dostępnych lat szkolnych.
      </div>
    );
  }

  return (
    <div className="rounded-[24px] border border-white/70 bg-white/78 px-5 py-4 shadow-[0_12px_28px_rgba(15,23,42,0.05)] backdrop-blur-sm">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-400">
            Rok szkolny
          </div>
          <div className="mt-1 text-sm font-semibold text-slate-800">
            {getSchoolYearLabel(selectedSchoolYear)} - {statusLabel(selectedSchoolYear?.status)}
          </div>
        </div>

        <select
          value={selectedSchoolYearId ?? ""}
          onChange={(e) => setSelectedSchoolYearId(e.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 outline-none transition-colors focus:border-emerald-300 sm:w-72"
        >
          {schoolYears.map((year) => (
            <option key={year.id} value={year.id}>
              {getSchoolYearLabel(year)} - {statusLabel(year.status)}
            </option>
          ))}
        </select>
      </div>

      {isSelectedYearDraft && (
        <div className="mt-3 rounded-2xl border border-sky-200 bg-sky-50 px-4 py-3 text-sm font-medium text-sky-800">
          Wersja robocza roku szkolnego. Dane mogą edytować wyłącznie administratorzy.
        </div>
      )}

      {isSelectedYearArchived && (
        <div className="mt-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-medium text-amber-800">
          Rok tylko do odczytu.
        </div>
      )}
    </div>
  );
}
